var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6252,
    cy: 26.5769,
    r: 26.4768,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0625 17.542V35.6867L26.8565 39.996V21.6246L39.6712 16.8616L27.9906 12.7791L15.0625 17.542Z",
    fill: "#00E599"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7656 22.3048V32.0576L39.6731 36.3669V17.8821L27.7656 22.3048Z",
    fill: "#00AF92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeoIcon);
export default __webpack_public_path__ + "static/media/neoIcon.90e0a8e3f036e558ad2d370fc80cb391.svg";
export { ForwardRef as ReactComponent };